import React from 'react';
import './GDMerchantNumberCell.scss';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import sha1 from 'js-sha1';

const GDMerchantNumberCell = ({ merchantName, merchantNumber, extraClass }) => {
  let colFlag = false;
  const rowLen = 15;
  const colNameLength = merchantName.trim().length;


  const wrapperClass = classnames('gd-color-coded-cell', {
    [extraClass]: extraClass,
  });

  const hashedColor = sha1(merchantName).substr(0, 6);

  const indicator = (
    <span
      className="gd-color-coded-cell__indicator"
      style={{ backgroundColor: `#${hashedColor}` }}
    />
    );

  if (colNameLength > rowLen) {
    colFlag = true;
  }
  return (
    <div className={wrapperClass}>
      {indicator}
      <span className="gd-merchant-number-cell__value">{merchantName}</span>
      <span className="gd-merchant-number-cell__merchant-number">{merchantNumber}</span>
    </div>
  );
};

GDMerchantNumberCell.propTypes = {
  merchantName: PropTypes.string.isRequired,
  merchantNumber: PropTypes.any.isRequired,
};

GDMerchantNumberCell.defaultProps = {
  merchantName: '',
  merchantNumber: '',
}

export default GDMerchantNumberCell;
